import { chain, cloneDeep, forOwn, get, keys, size } from 'lodash';
import { controllerTypes, parameterStatuses, statusesAssociatedWithRequestedValue, toggleCurrentValueMap } from './constants';

export const getUpdatedFields = (initialValues, values, fields) => {
  const diff = {};

  forOwn(values, (value, key) => {
    if (initialValues[key] !== value) {
      diff[key] = value;
    }
  });

  if (fields && size(fields)) {
    forOwn(fields, (value, key) => {
      if (value && value.touched) {
        diff[key] = values[key];
      }
    });
  }

  return diff;
};

export const humanizeName = (name) =>
  chain(name)
    .replace((name) => name, '_', ' ')
    .startCase((name) => name)
    .value();

export const getProcessedStatus = (dirty, status) => (dirty ? parameterStatuses.MODIFIED : status);

const getMultiValues = (availableValues, value) => {
  const values = value ? value.split(',') : [];
  const filteredValues = availableValues.filter((availableValue) => values.includes(availableValue.value));

  return filteredValues.map((filteredValue) => filteredValue.label);
};

export const getCurrentValue = (controllerType, availableValues, value) => {
  if (controllerType === controllerTypes.toggle) {
    return toggleCurrentValueMap[value];
  }

  const currentValue = size(availableValues) && getMultiValues(availableValues, value).join(', ');

  if (currentValue) {
    return currentValue;
  }

  return value || '';
};

export const getUpdatedParameters = (diff, fieldsPathMap) => {
  const updatedParameters = {
    nodes: [],
  };

  Object.keys(diff).forEach((fieldPath) => {
    const updatedField = fieldsPathMap[fieldPath];
    const updatedParameter = {
      parameter_name: updatedField.defaultName,
      value: diff[fieldPath],
    };
    const updatedNode = updatedParameters.nodes.find((item) => item.node_name === updatedField.node);

    if (updatedNode) {
      updatedNode.parameters.push(updatedParameter);
    } else {
      updatedParameters.nodes.push({
        node_name: updatedField.node,
        parameters: [updatedParameter],
      });
    }
  });

  return updatedParameters;
};

export const getProcessedDiff = (diff, fieldsPathMap, values) => {
  const processedDiff = cloneDeep(diff);

  keys(fieldsPathMap)
    .filter((parameterPath) => get(fieldsPathMap[parameterPath], 'status') !== parameterStatuses.LIVE)
    .forEach((nonLiveParameterPath) => {
      if (statusesAssociatedWithRequestedValue.indexOf(get(fieldsPathMap[nonLiveParameterPath], 'status')) !== -1) {
        processedDiff[nonLiveParameterPath] = get(fieldsPathMap[nonLiveParameterPath], 'requested_value');
      } else {
        processedDiff[nonLiveParameterPath] = values[nonLiveParameterPath];
      }
    });

  return processedDiff;
};
